'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwaggerUI = require('./SwaggerUI');

var _SwaggerUI2 = _interopRequireDefault(_SwaggerUI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _SwaggerUI2.default;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/index.js');
}();

;